module.exports = __webpack_public_path__ + "img/coples_y_elementos.1772ed82.jpg";